/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './removeOptions.defs.js'
export * as $defs from './removeOptions.defs.js'
